export default "__VITE_ASSET__zN_aIFjV__"